import GoalCompletionStatsCard from "./GoalCompletionStatsCard"
export default GoalCompletionStatsCard
